import { Signal, createRoot, createSignal } from 'solid-js'
import type { MainMenuObj } from '../../../components/ModalMenu/MainMenuObj.type'
import type { Nullable } from '../../../typescript'

const signal: Signal<Nullable<MainMenuObj>> = createRoot(() => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Nullable<MainMenuObj>>()

  return signal
})

export const [getModalMenu, setModalMenu] = signal
